import Actions from './locales.actions';
import { localesObjectToMessages } from './locales.util';
import { Actions as ToastActions } from 'domains/core/notification';
import { localesServiceConfiguration } from 'domains/core/config/selectors';
import { locales } from 'api';

export const fetchInitialLocale = locale => dispatch => {
  dispatch(Actions.initializeLocale());
  return dispatch(fetchLocale(locale));
};

export const fetchSwitchedLocale = locale => dispatch => {
  dispatch(Actions.switchLocale());
  return dispatch(fetchLocale(locale));
};

export const fetchLocale = locale => async (dispatch, getState) => {
  try {
    const translations = await locales.getTranslations(
      locale,
      localesServiceConfiguration(getState())
    );
    dispatch(
      Actions.loadDynamicMessages(
        'translations',
        localesObjectToMessages(translations, locale)
      )
    );
    dispatch(Actions.selectLocale(locale));
  } catch (err) {
    dispatch(ToastActions.error(err.message));
  }
};
